<template>
  <v-row no-gutters>
    <v-col cols="6">
      <SelectPicker
        v-model="startTime"
        subtitle="Début"
        :items="computedStartTime"
      />
    </v-col>
    <v-col cols="6">
      <SelectPicker
        v-model="endTime"
        subtitle="Fin"
        :items="computedEndTime"
      />
    </v-col>
    <v-col cols="6" />
    <v-col cols="6" justify="end">
      <v-btn class="white--text" color="third" @click="timeFilter">Appliquer</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { endOfDay, getUnixTime, startOfDay } from 'date-fns';
import { startTimeOptions, endTimeOptions } from '../../helpers/dataManager';
import SelectPicker from '@/components/common/Form/SelectPicker.vue';
import store from '@/store';

export default {
  components: { SelectPicker },
  setup () {
    const computedStartTime = computed(() => startTimeOptions());
    const computedEndTime = computed(() => endTimeOptions());

    const sideBarFilters = computed(() => store.getters.sideBarFilters);

    const selectedDate = computed(() => store.getters.selectedDate);

    const startTime = ref(null);
    const endTime = ref(null);

    const timeFilter = () => {
      store.commit('setIsSessionFilterApplied', !!(startTime.value || endTime.value));

      let start = getUnixTime(startOfDay(new Date(selectedDate.value)));
      let end = getUnixTime(endOfDay(new Date(selectedDate.value)));

      if (startTime.value) {
        start = getUnixTime(new Date(`${selectedDate.value}T${startTime.value}`));
      }

      if (endTime.value) {
        end = getUnixTime(new Date(`${selectedDate.value}T${endTime.value}`));
      }

      const toStore = { ...sideBarFilters.value };

      store.commit('setSideBarFilters', { ...toStore, session: { start_time: start, end_time: end } });
    };

    return { timeFilter, computedStartTime, computedEndTime, startTime, endTime };
  }
};

</script>
